import { render, staticRenderFns } from "./static-form-builder.vue?vue&type=template&id=6d251722&scoped=true"
import script from "./static-form-builder.vue?vue&type=script&lang=js"
export * from "./static-form-builder.vue?vue&type=script&lang=js"
import style0 from "./static-form-builder.vue?vue&type=style&index=0&id=6d251722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d251722",
  null
  
)

export default component.exports